import { authFetch, buildAuthHeaders } from "../../../public/api/httpClient";
import { SCHEDULE_API_ROUTES } from "../utils/scheduleApiRoutes";
import { authJsonHeaders, buildApiError, parseJson } from "./apiHelpers";

const BASE = SCHEDULE_API_ROUTES.priorityTypes;

export async function getPriorityTypes() {
  const res = await authFetch(BASE, {
    credentials: "include",
    headers: buildAuthHeaders(),
  });
  const data = await parseJson(res);
  if (!res.ok) throw buildApiError(res, data, "Failed to fetch priority types");
  return data;
}

export async function getPriorityTypesDropdown() {
  const res = await authFetch(`${BASE}/dropdown`, {
    credentials: "include",
    headers: buildAuthHeaders(),
  });
  const data = await parseJson(res);
  if (!res.ok) throw buildApiError(res, data, "Failed to fetch priority types");
  return data;
}

export async function createPriorityType(body, csrfToken) {
  const res = await authFetch(BASE, {
    method: "POST",
    credentials: "include",
    headers: buildAuthHeaders(authJsonHeaders(csrfToken)),
    body: JSON.stringify(body),
  });
  const data = await parseJson(res);
  if (!res.ok) throw buildApiError(res, data, "Failed to create priority type");
  return data;
}

export async function updatePriorityType(id, body, csrfToken) {
  const res = await authFetch(`${BASE}/${encodeURIComponent(String(id))}`, {
    method: "PUT",
    credentials: "include",
    headers: buildAuthHeaders(authJsonHeaders(csrfToken)),
    body: JSON.stringify(body),
  });
  const data = await parseJson(res);
  if (!res.ok) throw buildApiError(res, data, "Failed to update priority type");
  return data;
}

export async function changePriorityTypeStatus(id, statusId, csrfToken) {
  const res = await authFetch(`${BASE}/${encodeURIComponent(String(id))}/status`, {
    method: "PATCH",
    credentials: "include",
    headers: buildAuthHeaders(authJsonHeaders(csrfToken)),
    body: JSON.stringify({ status_id: Number(statusId) }),
  });
  const data = await parseJson(res);
  if (!res.ok) throw buildApiError(res, data, "Failed to change priority type status");
  return data;
}

export async function deletePriorityType(id, csrfToken) {
  const res = await authFetch(`${BASE}/${encodeURIComponent(String(id))}`, {
    method: "DELETE",
    credentials: "include",
    headers: buildAuthHeaders(authJsonHeaders(csrfToken)),
  });
  const data = await parseJson(res);
  if (!res.ok) throw buildApiError(res, data, "Failed to delete priority type");
  return data;
}
